import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  FormControl,
  FormControlLabel,
  FormHelperText,
  RadioGroup,
  Radio,
} from '@material-ui/core';
import FormField from '../../../_components/Authorization/FormField';

const useStyles = makeStyles((theme) => ({
  block: {
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: '1px solid #eee',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  blockTitle: {
    fontSize: '18px',
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: theme.palette.black,
  },
  radioGroup: {
    marginBottom: theme.spacing(2),
  },
  paymentOption: {
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    border: '1px solid transparent',
    borderRadius: '4px',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      borderColor: theme.palette.primary.light,
    },
  },
  paymentOptionSelected: {
    backgroundColor: '#f0f7ff',
    borderColor: theme.palette.primary.main,
  },
  paymentLabel: {
    fontWeight: 500,
    fontSize: '14px',
  },
  paymentDescription: {
    fontSize: '12px',
    color: '#666',
    marginTop: theme.spacing(0.5),
  },
  errorText: {
    fontSize: '12px',
    color: theme.palette.error.main,
    marginTop: '4px',
  },
  edrpouField: {
    marginTop: theme.spacing(2),
  },
}));

/**
 * PaymentBlock - Блок "Оплата" (НОВИЙ)
 * Варіанти: Liqpay, Готівка, MonoBank, ПриватБанк, ПісляПлата, Рахунок ФОП/ТОВ
 */
const PaymentBlock = ({
  formState,
  errors,
  handleSelectChange,
  listTypePayment,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const paymentApiList = listTypePayment?.dataPayment?.results || [];

  const paymentMethods =
    paymentApiList.length > 0
      ? paymentApiList.map((item) => ({
          id: item.code || item.value || item.id || item.name,
          label:
            item.name || item.title || item.label || item.code || item.id,
          description: item.description || item.subtitle || '',
        }))
      : [
        //   {
        //     id: 'liqpay',
        //     label: 'Liqpay',
        //     description: t('paymentOnline') || 'Онлайн платіж',
        //   },
        //   {
        //     id: 'cash',
        //     label: t('cash') || 'Готівка',
        //     description: t('paymentOnDelivery') || 'Оплата при отриманні',
        //   },
        //   {
        //     id: 'monobank',
        //     label: 'MonoBank',
        //     description: t('bankTransfer') || 'Переказ на карту',
        //   },
        //   {
        //     id: 'privatbank',
        //     label: 'ПриватБанк',
        //     description: t('bankTransfer') || 'Переказ на карту',
        //   },
          {
            id: 'postpaid',
            label: t('postpaid') || 'ПісляПлата',
            description: t('paymentAfterDelivery') || 'Оплата після доставки',
          },
          {
            id: 'invoice',
            label: t('invoiceCompany') || 'Рахунок ФОП/ТОВ',
            description: t('invoiceDescription') || 'За рахунком для компанії',
          },
        ];

  return (
    <Box className={classes.block}>
      <Typography className={classes.blockTitle}>
        💳 {t('payment') || 'Оплата'}
      </Typography>

      <FormControl 
        component="fieldset" 
        error={!!errors?.payment}
        fullWidth
      >
        <RadioGroup
          name="payment"
          value={formState.values.payment || ''}
          onChange={handleSelectChange}
          className={classes.radioGroup}
        >
          {paymentMethods.map((method) => (
            <FormControlLabel
              key={method.id}
              value={method.id}
              control={<Radio />}
              label={
                <Box>
                  <Typography className={classes.paymentLabel}>
                    {method.label}
                  </Typography>
                  <Typography className={classes.paymentDescription}>
                    {method.description}
                  </Typography>
                </Box>
              }
              className={`${classes.paymentOption} ${
                formState.values.payment === method.id ? classes.paymentOptionSelected : ''
              }`}
            />
          ))}
        </RadioGroup>

        {errors?.payment && (
          <FormHelperText error className={classes.errorText}>
            {errors.payment[0]}
          </FormHelperText>
        )}
      </FormControl>

      {/* Додаткове поле для рахунку компанії */}
      {formState.values.payment === 'invoice' && (
        <Box className={classes.edrpouField}>
          <FormField
            handleChange={handleSelectChange}
            name="edrpou"
            title={t('edrpou') || 'EDRPOU'}
            type="text"
            formState={formState}
            hasErrorText={errors?.edrpou ? errors.edrpou[0] : ''}
          />
        </Box>
      )}
    </Box>
  );
};

export default PaymentBlock;
